class TipoPagamentoEnum {
  constructor() {
    this.POR_TONELADA = 1;
    this.POR_FRETE_CHEIO = 2;
  }

  /**
   * @returns {Array<{value: number, label: string}>}
   */
  getValues() {
    return [
      { value: this.POR_TONELADA, label: 'Por tonelada' },
      { value: this.POR_FRETE_CHEIO, label: 'Frete cheio' },
    ];
  }

  /**
   * @param {number} value
   * @returns {string}
   */
  getTipoPagamentoLote(value) {
    return this.getValues().find(item => item.value === value).label;
  }
}

export default new TipoPagamentoEnum();
